module.exports = __webpack_public_path__ + "static/img/fission-head.95b7802.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/fission-head.png
// module id = wydt
// module chunks = 216